module.exports = __webpack_public_path__ + "static/media/areamap3.c6300c9e.svg";